import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';
import styles from './Profile.module.css';
import { setLogout } from '../../state/GlobalState';
import { isLoggedIn, doLogout } from "../../auth";
import { Grid, Box} from '@mui/material';
import {Modal} from '@mui/material';
import ModalComponent from '../ModalComponent/ModalComponent';
import { Image } from 'cloudinary-react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  height: 300,
  backgroundColor:'white',
  padding:'5%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
};

const Profile = ({ data }) => {
  
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleMobileOpen = () => setMobileOpen(true);
    const handleMobileClose = () => setMobileOpen(false);

  
  const navigate = useNavigate();
  const name = useSelector((state) => state.globalData.name);
  const count = useSelector((state) => state.globalData.notificationCount);
  const dispatch = useDispatch();

  const token = useSelector((state) => state.globalData.token);
  const userDetails = useSelector((state) => state.globalData.userDetails);
  const [businessData, setBusinessData] = useState({
    id: userDetails.id || "",
    name: userDetails.name || "",
    email: userDetails.email || "",
    password: "",
    phoneNumber: userDetails.phoneNumber || "",
    roles: userDetails.roles?.name || '',
  });

  const [isFieldEdited, setIsFieldEdited] = useState(false);

  useEffect(() => {
    if (data) {
      setBusinessData({
        name: data.userDetail.name,
        email: data.userDetail.email,
        password: '',
        phoneNumber: data.userDetail.phoneNumber,
        username: data.userDetail.username,
      });
    }
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBusinessData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setIsFieldEdited(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (!isFieldEdited) {
        navigate('/dashboard');
        // No API call if no field is edited
        return;
        
      }
      

      const requestData = {
        name: businessData.name,
        email: businessData.email,
        password: businessData.password,
        phoneNumber: businessData.phoneNumber,
        roles: { name: businessData.roles },
        username: userDetails.username,
      };

      const eventResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/superAdmin/editUser/${businessData.id}`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );

      dispatch(fetchNotifications());
      dispatch(setNotificationCount({ count: count + 1 }));

      logout();
      // navigate('/login');
    } catch (error) {
      
      console.error(error);
    }
  };

  const logout = () => {
    dispatch(setLogout());
      navigate('/login');
  };


  return (
    <div style={{backgroundColor:'#fff',boxShadow:'0px 0px 2px 0px',padding:'1%',width:'100%'}}>
      <form onSubmit={handleSubmit}>
         <Typography sx={{mb:'2%'}}>My Profile</Typography>
         <Typography  sx={{borderTop:'2px solid black'}}></Typography>
         <Typography  className={styles.hen}>General Information</Typography>
  <Box sx={{width:'100%',display:'flex'}}>
    <Box sx={{width:'70%',gap:'5%'}}>
       
       <Box sx={{width:'100%',display:'flex'}}>
       <Grid container spacing={3} className={styles.formContainer} >
         <Grid item xs={12} sm={6} lg={6}>
           <label htmlFor="firstName">Full Name:</label>
           <input
            type="text"
            value={businessData?.name || ''}
            name="name"
            onChange={handleInputChange}
           />
         </Grid>
         <Grid item xs={12} sm={6} lg={6}>
           <label htmlFor="lastName">User Name:</label>
           <input
             type="text"
             id="lastName"
             name="lastName"
            
           />
         </Grid>
         </Grid>
         </Box>
       
         <Box sx={{width:'100%',display:'flex',mt:'2%'}}>
       <Grid container spacing={3} className={styles.formContainer} >
         <Grid item xs={12} lg={6}>
           <label htmlFor="email">Email:</label>
           <input
              type="text"
              value={businessData?.email || ''}
              name="email"
              onChange={handleInputChange}
           />
         </Grid>
         <Grid item xs={12} lg={6}>
           <label htmlFor="Mobile Number">Mobile Number:</label>
           <TextField
               type="text"
               value={businessData?.phoneNumber || ''}
               name="phoneNumber"
               onChange={handleInputChange}
               InputProps={{
                endAdornment: (
                  <Button
                    variant="outlined"
                    className="buttonWithPadding"
                    sx={{ textTransform: 'capitalize' }}
                    onClick={handleOpen}
                  >
                    Change
                  </Button>
                  
                  

                ),
              }}
           />
            <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
         <Box style={style}>
   <ModalComponent/>
            </Box>
          </Modal>
           
         </Grid>
         </Grid>
         </Box>
         
        
         <Box sx={{width:'100%',display:'flex',mt:'2%'}}>
       <Grid container spacing={3} className={styles.formContainer} >
         
         <Grid item xs={12} lg={6}>
           <label htmlFor="number">Registered on:</label>
           <input
             type="number"
             id="number"
             name="number"
            
           />
         </Grid>
         <Grid item xs={12} lg={6}>
           <label htmlFor="confirmPassword">Role:</label>
           <input
            type="text"
            value={businessData?.roles || ''}
            name="roles"
            onChange={handleInputChange}
            disabled 
           />
         </Grid>
         
         </Grid>
         </Box>
         
   
       
       </Box>
       <Box>
           
           <Grid item xs={12} lg={4} className={styles.imageContainer}>
              <Box sx={{ width: '500px' }}>
       <AccountCircleIcon sx={{ color: '#DAE6FC', fontSize: '132px',ml:'23%' }} />
       <Button   sx={{ml:'-22%',mt:'5%'}}>Edit Photo</Button>
    

     </Box>
     <Box>
     <Button variant="outlined"  sx={{mt:'9%',ml:'20%'}}>Change password</Button>
     </Box>
            
              </Grid>
           </Box>
       </Box>
         <Grid item xs={4}>
           <Button
            variant="contained" type="submit" 
             
           >
            Update & Save
           </Button>
         </Grid>
      
        
         
     </form>
 
  
 
 
 </div>
  );
};

export default Profile;